import CartItem from '@/classes/CartObject';

class AccomodationCartItem extends CartItem {
  type = 'ACCOMODATION';
  poolLid = null;
  unitLid = null;
  period = null;
  week = null;

  site = null;

  adults = 0;
  seniors = 0;
  youths = 0;
  children = 0;

  capacity = 0;

  editableQuantity = false;

  constructor() {
    super();
    return true;
  }

  static peopleCount(model) {
    return CartItem.number(model.adults) + CartItem.number(model.youths)
    + CartItem.number(model.children) + CartItem.number(model.seniors);
  }
}

export default AccomodationCartItem;



// WEBPACK FOOTER //
// ./src/classes/AccomodationCartItem.js